export const duplicate_offering_available =
  "host/allowed/duplicated/entities/get";
export const duplicate_listing = "host/listing/duplicate";
export const FETCH_OFFERINGS_LIST = "host/listing/paginated/list";
